export default {
  props: {
    src: String,
  },

  data() {
    return {
      hasError: null,
    };
  },

  methods: {
    handleImageLoadError,
  },
};

function handleImageLoadError() {
  this.hasError = true;
}
